module.exports = __webpack_public_path__ + "img/deuda-clientes.57897471.png";